export const environment = {
    url: process.env.REACT_APP_API_URL,
    managerUrl: process.env.REACT_APP_MANAGER_API_URL,
    managerFrontendUrl: process.env.REACT_APP_MANAGER_FRONTEND_URL,
    employeeFrontendUrl: process.env.REACT_APP_EMPLOYEE_FRONTEND_URL,
    instrumentationKey: 'e146bbe7-88c0-43f5-ae23-7558957b2bb5',
};
